import { SERVICEURI } from "../const/serviceuri";
import { getRequest } from "../Instance/fetchRequest";
import configData from "../config.json";

const searchResultQuery = ({ key, q }) => {
  let endPoint = SERVICEURI.Search
  .replace("{key}", key)
  .replace("{q}", q);
  
  //define API endpoint
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    console.log("searchResultsService::searchResultQuery() DEVELOPMENT MODE.");
  }
  else {
    console.log("searchResultsService::searchResultQuery() PRODUCTION MODE.");
    if (configData.enthapiuri) {
      console.log("searchResultsService::searchResultQuery() configData.enthapiuri: ",  configData.enthapiuri);
      endPoint = configData.enthapiuri + endPoint;
    }
    else {
      console.log("searchResultsService::searchResultQuery() configData.enthapiuri missing, default to https://www.enth.com/.");
      endPoint = "https://www.enth.com/" + endPoint;
    }
  }
  //console.log("searchResultsService::searchResultQuery() endPoint: ",  endPoint);

  return new Promise(async (onSuccess, onFailure) => {
    await getRequest(endPoint)
      .then((response) => {
        console.log("searchResultsService::searchResultQuery() success");
        onSuccess(response);
      })
      .catch((error) => {
        console.log("searchResultsService::searchResultQuery() Exception Encountered: ", error);
        onFailure(error);
      });
  });
};

const getResults = ({ key, id }) => {
  let endPoint = SERVICEURI.Results
  .replace("{key}", key)
  .replace("{id}", id);

   //define API endpoint
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    console.log("searchResultsService::getResults() DEVELOPMENT MODE ID: ", id);
  }
  else {
    console.log("searchResultsService::getResults() PRODUCTION MODE ID: ", id);
    if (configData.enthapiuri) {
      console.log("searchResultsService::getResults() configData.enthapiuri: ",  configData.enthapiuri);
      endPoint = configData.enthapiuri + endPoint;
    }
    else {
      console.log("searchResultsService::getResults() configData.enthapiuri missing, default to https://www.enth.com/.");
      endPoint = "https://www.enth.com/" + endPoint;
    }
  }
 
  return new Promise(async (onSuccess, onFailure) => {
    await getRequest(endPoint, id)
      .then((response) => {
        if (response.output === 'in process') {
          console.log("searchResultsService::getResults()  ID: ", id, "In Process");
        } else {
          console.log("searchResultsService::getResults()  ID: ", id, "Success");
          onSuccess(response);
        }
      })
      .catch((error) => {
        console.log("searchResultsService::getResults() Exception Encountered: ",  "ID: ", id,  error);
        onFailure(error);
      });
  });
};

//Deprecated
/*const searchLocationIp = (endPoint) => {
  return new Promise(async (onSuccess, onFailure) => {
    await getRequest(endPoint)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onFailure(error);
      });
  });
};*/

const randomLinechartLocationIP = (endPoint) => {
  return new Promise(async (onSuccess, onFailure) => {
    await getRequest(endPoint)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onFailure(error);
      });
  });
};

const barChartData = (endPoint) => {
  return new Promise(async (onSuccess, onFailure) => {
    await getRequest(endPoint)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        onFailure(error);
      });
  });
};

const SearchResult = {
  searchResultQuery,
  getResults,
  //searchLocationIp,
  randomLinechartLocationIP,
  barChartData,
};

export default SearchResult
